











import {Component, Emit, Model, Prop, Vue, Watch} from 'vue-property-decorator';

Component.registerHooks([
  'beforeRouteEnter',
]);

@Component({
  components: {},
})
export default class DirectionSwitch extends Vue {
  @Model('change') public model!: any;
  @Prop(String) public onText!: string;
  @Prop(String) public offText!: string;

  private value: boolean = false;

  @Watch('value')
  @Emit('change')
  protected onValueChange(value: any | null) {
    return value;
  }

  @Watch('model', {immediate: true})
  protected onModelChange(value: any | null) {
    this.value = value;
  }

}
